'use client';

import { clsx } from 'clsx';
import React, { forwardRef } from 'react';
import { createUseStyles } from 'react-jss';
import styles from './ObjectPageSection.jss.js';
const useStyles = createUseStyles(styles, {
  name: 'ObjectPageSection'
});
/**
 * Top-level information container of an `ObjectPage`.
 */
const ObjectPageSection = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    titleText = '',
    id,
    children,
    titleTextUppercase = true,
    className,
    style,
    hideTitleText,
    titleTextLevel = 'H3',
    wrapTitleText,
    header,
    ...rest
  } = props;
  const classes = useStyles();
  const htmlId = `ObjectPageSection-${id}`;
  const titleClasses = clsx(classes.title, titleTextUppercase && classes.uppercase);
  return /*#__PURE__*/React.createElement("section", {
    ref: ref,
    role: "region",
    className: clsx(classes.section, wrapTitleText && classes.wrap, className),
    style: style,
    ...rest,
    id: htmlId,
    "data-component-name": "ObjectPageSection"
  }, !!header && /*#__PURE__*/React.createElement("div", {
    className: classes.headerContainer
  }, header), !hideTitleText && /*#__PURE__*/React.createElement("div", {
    role: "heading",
    "aria-level": parseInt(titleTextLevel.slice(1)),
    className: classes.titleContainer,
    "data-component-name": "ObjectPageSectionTitleText"
  }, /*#__PURE__*/React.createElement("div", {
    className: titleClasses
  }, titleText)), /*#__PURE__*/React.createElement("div", {
    className: classes.sectionContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.sectionContentInner,
    "data-component-name": "ObjectPageSectionContent"
  }, children)));
});
ObjectPageSection.displayName = 'ObjectPageSection';
export { ObjectPageSection };